import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// TV-WebView feature detection
//
// Old Android-stick WebViews (Chrome <84) DO NOT support flex `gap`. When we
// detect it doesn't work, we tag <html> so the polyfill CSS in index.css can
// activate margin-based spacing. Modern browsers retain native `gap` behavior.
//
// Runs synchronously before React mounts so first paint is already correct.
// ---------------------------------------------------------------------------
(function detectLegacyWebView() {
  try {
    // Use two explicit zero-height/zero-width block children so the probe's
    // scrollHeight is *only* affected by the row-gap, not by inherited
    // line-height (which is what made our previous <i>-based probe lie).
    const probe = document.createElement("div");
    probe.style.cssText =
      "position:absolute;visibility:hidden;display:flex;" +
      "flex-direction:column;row-gap:1px;width:1px;line-height:0;";
    const a = document.createElement("div");
    const b = document.createElement("div");
    a.style.cssText = "width:1px;height:0;line-height:0;";
    b.style.cssText = "width:1px;height:0;line-height:0;";
    probe.appendChild(a);
    probe.appendChild(b);
    document.documentElement.appendChild(probe);
    const supported = probe.scrollHeight === 1; // exactly the 1px gap
    probe.parentNode.removeChild(probe);
    if (!supported) {
      document.documentElement.classList.add("no-flex-gap");
    }
  } catch (_e) {
    // If anything throws (extremely old WebView), assume legacy.
    document.documentElement.classList.add("no-flex-gap");
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
